import { Box, Typography } from "@mui/material";
import { DoorFrontTwoTone } from "@mui/icons-material";
import DoorIcon from "../../_icons/door";
export default function DoorPointMarker({
  name,
  handleLocationSelect,
  rotation
}: {
  name: string,
  handleLocationSelect?: (name: string) => void,
  rotation?: number
}) {
  return (
    <>
      <Box
        onClick={() => handleLocationSelect?.(name)}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyItems: 'center',
          position: 'relative',
          transform: `rotate(${rotation || 0}deg)`
        }}
      >
        <DoorIcon />
        <Typography
          variant="subtitle2"
          sx={{
            marginTop: '-4px',
            color: '#363636',
            fontSize: '14px',
            textAlign: "center",
            wordBreak: 'keep-all',
            width: '100%'
          }}
        >
          {name}
        </Typography>
      </Box>
    </>
  )
}